import { NavLink, useLocation } from 'react-router-dom';
import { settingSideBarLinks } from 'data';

const SettingSideBar = () => {
    const location = useLocation();

    return (
        <div className="animate-fadeUp">
            <h1 className="text-lg font-bold text-achromatic-900 mb-4">설정</h1>
            <div className="bg-white rounded-2xl overflow-hidden">
                {settingSideBarLinks.map((link, index) => (
                    <NavLink
                        key={index}
                        to={link.href}
                        className={({ isActive }) =>
                            `flex items-center justify-between py-4 px-5 transition-colors ${
                                index < settingSideBarLinks.length - 1 ? 'border-b border-achromatic-50' : ''
                            } ${
                                isActive && location.pathname !== '/setting'
                                    ? 'text-achromatic-900 bg-primary-50'
                                    : 'text-achromatic-600 hover:bg-achromatic-50'
                            }`
                        }
                    >
                        <span className="text-sm font-semibold">{link.title}</span>
                        <svg className="w-4 h-4 text-achromatic-300" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                        </svg>
                    </NavLink>
                ))}
            </div>
        </div>
    );
};

export default SettingSideBar;